// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import classNames from "classnames"
// MUI
import { withStyles} from "@material-ui/core/styles"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// FLASH
//import FlashLogo from "../static/images/lightning-logo-transparent.png" // original
//import FlashLogo from "../static/images/pulseai/pulseai.logo2.png"
import FlashLogo from "../static/images/pulseai/pulseai.logo2.2.png" // this is 144px high which is scaled with icon

// LOGGING SETUP
import appConfig from "./../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashSplash>")

const styles = theme => {
    return {

        //
        // desktop
        //
        "@keyframes splashAnimation":  {
            "0%": {
                opacity: 1
            },
        
            "100%": {
                opacity: 0,
                zIndex: -1,
            },
        },


        "@keyframes headerAnimation":  {
            "0%": {
                opacity: 0,
            },

            "100%": {
                opacity: 1,
            },
        },
        
        messageRoot: {
            position: "fixed",
            top: 0,
            left: 0,
            margin:0,
            padding: 0,
            background: theme.palette.primary.main,
            "z-index": 1500,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",

            animationName: "$splashAnimation",
            animationFillMode: "forwards",

            /*
            animationDelay: "2s",
            animationDuration: "2s",
            */

            animationDelay: "0.5s",
            animationDuration: "1s",

        },

        headerRoot: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            //            alignItems: "center",
            margin: 0,
//            marginBottom: 10,
            padding: 0,
//            marginBottom: 10,
            
            animationName: "$headerAnimation",
//            animationDelay: "0s",
            animationDuration: "0.2s",
            animationFillMode: "forwards",
        }
    }
}

{/*
class FlashSplash extends Component {
    render() {
        const { classes } = this.props
        return (
            <div className={classes.messageRoot}>
              <div className={classes.headerRoot} style={{color: "white", fontSize: 36, fontWeight: "bold", marginTop: -100}}>
                  Lightning
              </div>
              <div className={classes.headerRoot} style={{color: "white", fontSize: 24, marginTop: 8, marginBottom: 25}}>
                Be heard. Have an impact
              </div>
              <div>
                <img alt="logo" src={FlashLogo}/>
              </div>
            </div>
        )
    }
}
 */}

class FlashSplash extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.messageRoot}>
              <div>
                <img alt="logo" src={FlashLogo}/>
              </div>
              <div className={classes.headerRoot} style={{color: "white", fontSize: 24, marginTop: 8, marginBottom: 25}}>
                Be heard. Have an impact.
              </div>
            </div>
        );
    }
}



FlashSplash.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(FlashSplash)
